import React, { useState } from 'react';
import classnames from 'classnames';
import dayjs from 'dayjs';
import IconFont from '@/components/icon-font';
import Modal from '../modal';
import { getIncomeSource } from '@/utils/vip';
import * as native from '@/utils/native';
import { getUrlParam } from '@/utils';
import { GIFT_LEVEL_OPTIONS, TabType } from '@/constants/subscription';
import {
  PurchaseScene,
  SubscribeType,
  isTeamSubscription,
  purchaseScene,
  subscribeType,
} from '@/constants';
import { useAtom } from 'jotai';
import { curProductAtom, curTabAtom, giftLevelAtom, teamInfoAtom, vipInfoAtom } from '@/store';
import { Select } from 'antd';

import styles from './index.module.css';

interface IProps {
  isMeidouTab?: boolean;
  onRefresh?: () => void;
}

const ProductTip: React.FC<IProps> = (props: IProps) => {
  const { isMeidouTab, onRefresh } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [type, setType] = useState<string>('');

  const [curTab, setCurTab] = useAtom(curTabAtom);
  const [curProduct] = useAtom(curProductAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [giftLevel, setGiftLevel] = useAtom(giftLevelAtom);

  const url = 'https://mp.weixin.qq.com/s/1RQfGzdZ7Kkrsh5eI6FEiQ';

  const isPcBatch = getUrlParam('type') === 'svip';

  const handleJump = (jumpUrl: string) => {
    if (getIncomeSource() === 'MTXX-WEB') {
      window.open(jumpUrl);
    } else {
      native.openBrowser(jumpUrl);
    }
  };

  if (!curProduct) {
    return (
      <div className={styles.module}>
        <div className={styles.skeleton}>&nbsp;</div>
      </div>
    );
  }

  const renderQuestionIcon = (productType: string) => {
    return (
      <div
        className={styles.tooltip}
        onClick={() => {
          setType(productType);
          setVisible(true);
        }}
      >
        <IconFont name="questionmarkCircle" fontSize={20} />
      </div>
    );
  };

  const renderModalContent = () => {
    if (type === 'consumable') {
      return (
        <>
          <div className={styles.modalTitle} style={{ marginBottom: 16 }}>
            抠图张数赠送须知
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>如果您购买的是续期型会员：</div>
            <div className={styles.modalDescValue}>购买成功后将自动下发到您的当前账号</div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>如果您购买的是非续期会员：</div>
            <div className={styles.modalDescValue}>交易成功后将自动下发到您的当前账号</div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>抠图张数：</div>
            <div className={styles.modalDescValue}>
              以您实际购买的会员商品 在订购页上标记的赠送张数为准
            </div>
          </div>
          <div className={styles.modalDescRow}>
            <div className={styles.modalDescLabel}>抠图张数使用期限：</div>
            <div className={styles.modalDescValue}>以订购页实际展示的使用期限说明为准</div>
          </div>
          <div className={styles.modalDescRow} style={{ flexDirection: 'row' }}>
            <div className={styles.modalDescLabel}>体验地址：</div>
            <div
              className={classnames(styles.modalDescValue, styles.link)}
              onClick={() => handleJump('https://www.designkit.cn/cutout')}
            >
              www.designkit.cn/cutout
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className={styles.modalTitle}>服务须知</div>
        <div className={styles.modalDesc}>
          1.开通本服务后，将在会员到期前24小时内为您自动续费，续费成功会员自动延长对应周期时长；
        </div>
        <div className={styles.modalDesc}>2.您的续期代扣费用将从您绑定的支付账号中扣除；</div>
        <div className={styles.modalDesc}>3.您可随时取消自动续费服务，取消后将不再自动续费；</div>
        <div className={styles.modalDesc}>
          4.取消续订指南：
          <a onClick={() => handleJump(url)}>{url}</a>
        </div>
        <div className={styles.modalDesc}>5.如有其他问题可拨打客服热线 4000093360</div>
      </>
    );
  };

  const handleRenderTips = () => {
    if (isPcBatch) {
      // 批处理
      return (
        <div className={styles.desc}>
          使用抠图功能后完成1个图像下载保存，消耗&nbsp;
          <span style={{ color: '#fff', fontWeight: 'bolder' }}>10</span>
          &nbsp;张，其余功能消耗&nbsp;
          <span style={{ color: '#fff', fontWeight: 'bolder' }}>1</span>&nbsp;张
        </div>
      );
    }

    // 团队版，购买美豆文案
    if (curTab === TabType.MEIDOU && isTeamSubscription) {
      return (
        <>
          <div className={styles.descInfo}>
            <IconFont name="infoCircleBold" fontSize={18} color="rgba(255, 255, 255, 0.50)" />
            1年有效，仅支持在当前团队身份下使用
          </div>
          {!vipInfo?.is_vip ? (
            <div
              className={styles.desc}
              style={{
                fontSize: 14,
              }}
            >
              <span
                style={{
                  color: '#fff',
                }}
              >
                5人以上共享美豆请
              </span>
              &nbsp;
              <span
                style={{
                  color: 'var(--text-link)',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  // 默认5个席位
                  const url = new URL(window.location.href);
                  const params = url.searchParams;
                  params.set('seats', '5');
                  window.history.replaceState({}, '', url);

                  // 切购买会员
                  setCurTab(TabType.SUB);
                }}
              >
                开通团队版会员
              </span>
            </div>
          ) : null}
        </>
      );
    }

    // 团队版，加购席位场景
    if (curTab === TabType.SUB && isTeamSubscription && purchaseScene === PurchaseScene.EXTRA) {
      return (
        <div className={styles.desc}>
          <span>
            加购席位立即生效，于
            {dayjs((teamInfo?.active_order?.vip_end_time || 0) * 1000).format('YYYY-MM-DD')}
            到期（与生效中的团队版会员订单同步到期）
          </span>
        </div>
      );
    }

    // 团队版，购买会员场景
    if (curTab === TabType.SUB && isTeamSubscription) {
      // 低价试用是商品买赠，非试用商品是会员买赠
      const giftExplain = curProduct.isProbation
        ? curProduct.checkBox?.giftExplain
        : curProduct.checkBox?.vipGiftExplain;

      return giftExplain ? (
        <div className={styles.desc}>
          <span>{giftExplain}</span>
        </div>
      ) : null;
    }

    // 是否展示买赠文案模块
    const showGiftText =
      curTab === TabType.PRO_SUB ||
      (!isTeamSubscription && curTab === TabType.SUB && curProduct.checkBox?.vipGiftExplain);

    return (
      <>
        {showGiftText ? (
          <>
            <div className={styles.giftLevelRow}>
              <span className={styles.giftLevelIcon}>赠</span>
              {curTab === TabType.PRO_SUB ? (
                <>
                  <span className={styles.giftLevelLabel}>每月赠送，月内有效</span>
                  <Select
                    value={giftLevel}
                    size="small"
                    options={GIFT_LEVEL_OPTIONS}
                    className={styles.giftLevelSelect}
                    onChange={(value) => {
                      setGiftLevel(value);
                      onRefresh?.();
                    }}
                    dropdownClassName="giftLevelDropdown"
                  ></Select>
                </>
              ) : (
                <div className={styles.giftLevelLabel}>
                  {/* 个人版，会员买赠 */}
                  {curProduct.checkBox?.vipGiftExplain}
                </div>
              )}
            </div>
          </>
        ) : null}

        {/* 单购场景，且购买张数 */}
        {subscribeType === SubscribeType.CONSUMABLE && curTab === TabType.CUTOUT ? (
          <>
            {isTeamSubscription ? (
              <div className={classnames(styles.descInfo)}>
                <IconFont name="infoCircleBold" fontSize={18} color="rgba(255, 255, 255, 0.50)" />
                购买所得张数仅支持在当前团队身份下使用
              </div>
            ) : null}
            <div className={styles.desc} style={{ marginTop: 5 }}>
              <span>每成功下载1张图，扣除1张下载张数</span>
            </div>
            <div className={styles.desc}>
              <span>支持反复调整抠图效果，不发生下载则不扣除张数</span>
            </div>
          </>
        ) : null}

        {/* 抠图订阅场景下且购买会员，需要展示的固定文案 */}
        {subscribeType === SubscribeType.CONSUMABLE && curTab === TabType.SUB ? (
          <div className={styles.desc} style={{ marginTop: 5 }}>
            <span>会员有效期内抠图没有次数限制</span>
          </div>
        ) : (
          ''
        )}

        {/* 续期商品提示文案 */}
        {curProduct.checkBox?.explain ? (
          <div className={styles.desc}>
            <span>{curProduct.checkBox?.explain}</span>
            {renderQuestionIcon('renewedSubscription')}
          </div>
        ) : (
          ''
        )}

        {/* 个人版，美豆商品 */}
        {!isTeamSubscription && curTab === TabType.MEIDOU ? (
          <div className={styles.descInfo}>
            <IconFont name="infoCircleBold" fontSize={18} color="rgba(255, 255, 255, 0.50)" />
            有效期：{curProduct.productId === '7427746831138048106' ? '3个月' : '1年'}
          </div>
        ) : null}
      </>
    );
  };

  return (
    <div
      className={styles.module}
      style={{
        minHeight: isTeamSubscription ? '20px' : undefined,
      }}
    >
      {handleRenderTips()}

      <Modal
        visible={visible}
        wrapStyle={{ borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '0 12px 12px 0' }}
        style={{ width: 400, height: 'auto', backgroundColor: '#181A1C' }}
        onClose={() => setVisible(false)}
      >
        {renderModalContent()}
        <div className={styles.btn} onClick={() => setVisible(false)}>
          好的
        </div>
      </Modal>
    </div>
  );
};

export default React.memo(ProductTip);
